interface ApiConstantsInterface {
  baseUrl: string
  vouchers: string
  unlinkAccount: string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/ikonfriendsandfamily',
  vouchers: `/vouchers`,
  unlinkAccount: '/account/unlink',
}

export { apiConstants, ApiConstantsInterface }
